import { render, staticRenderFns } from "./baleSingleSku.vue?vue&type=template&id=2a2399ad&scoped=true&"
import script from "./baleSingleSku.vue?vue&type=script&lang=js&"
export * from "./baleSingleSku.vue?vue&type=script&lang=js&"
import style0 from "./baleSingleSku.vue?vue&type=style&index=0&id=2a2399ad&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a2399ad",
  null
  
)

export default component.exports